import BetDrawerLogic from "app/logic/betDrawerLogic";
import store from "app/store/store";
import cloneDeep from "lodash/cloneDeep";

export class betPanelHelper {
  static countExpandedCollapsedBetSlips() {
    // Some edge cases where this function causes the app to crash
    // seems to be when store is not ready yet
    const state = store.getState();
    if (
      !state?.betSlipListModel?.noOfBetSlipGroupdedEvents ||
      !state?.betBuilderModel?.betBuilderEvents
    ) {
      return;
    }

    // get the number of grouped single bet slips
    const groupedSingleBetSlips = cloneDeep(
      store.getState().betSlipListModel.noOfBetSlipGroupdedEvents
    );
    // get the number of bet builder bet slips
    let betBuilderEvents = cloneDeep(
      store.getState().betBuilderModel.betBuilderEvents
    );
    // get total number of all bet slips in the bet panel
    const totalAllBetSlips =
      groupedSingleBetSlips.length + Object.values(betBuilderEvents).length;

    // get the number of single bet slips that are expanded or collapsed
    const expandedSingleBetSlips = groupedSingleBetSlips.filter(
      event => !event.collapsed
    ).length;
    const collapsedSingleBetSlips = groupedSingleBetSlips.filter(
      event => event.collapsed
    ).length;

    // get the number of bet builder bet slips that are expanded or collapsed
    const collapsedBetBuilderEvents = Object.values(betBuilderEvents).filter(
      event => !event.isCollapsibleOpen
    ).length;
    const expandedBetBuilderEvents = Object.values(betBuilderEvents).filter(
      event => event.isCollapsibleOpen
    ).length;

    // calculate the total number of all bet slips that are expanded or collapsed
    const totalExpandedBetSlips =
      expandedSingleBetSlips + expandedBetBuilderEvents;
    const totalCollapsedBetSlips =
      collapsedSingleBetSlips + collapsedBetBuilderEvents;

    if (
      totalAllBetSlips === totalExpandedBetSlips &&
      totalExpandedBetSlips > 0
    ) {
      // update bet panel store to reflect all bet slips are expanded
      store.dispatch.betPanelManagerModel.updateBetPanelState({
        areAllBetSlipsExpanded: true,
        totalBetSlips: totalAllBetSlips,
        totalSingleBetSlips: groupedSingleBetSlips.length,
        totalBetBuilderBetSlips: Object.values(betBuilderEvents).length,
        totalCollapsedBetSlips: totalCollapsedBetSlips,
        totalExpandedBetSlips: totalExpandedBetSlips,
      });
    } else if (
      totalAllBetSlips === totalCollapsedBetSlips &&
      totalCollapsedBetSlips > 0
    ) {
      // update bet panel store to reflect all bet slips are collapsed
      store.dispatch.betPanelManagerModel.updateBetPanelState({
        areAllBetSlipsExpanded: false,
        totalBetSlips: totalAllBetSlips,
        totalSingleBetSlips: groupedSingleBetSlips.length,
        totalBetBuilderBetSlips: Object.values(betBuilderEvents).length,
        totalCollapsedBetSlips: totalCollapsedBetSlips,
        totalExpandedBetSlips: totalExpandedBetSlips,
      });
    } else {
      // update bet panel store to reflect some bet slips are expanded and some are collapsed
      store.dispatch.betPanelManagerModel.updateBetPanelState({
        totalBetSlips: totalAllBetSlips,
        totalSingleBetSlips: groupedSingleBetSlips.length,
        totalBetBuilderBetSlips: Object.values(betBuilderEvents).length,
        totalCollapsedBetSlips: totalCollapsedBetSlips,
        totalExpandedBetSlips: totalExpandedBetSlips,
      });
    }
  }

  static toggleExpandAllCollapseAllBetSlips() {
    // current stored value for  display collapse all text
    const areAllBetSlipsExpanded =
      store.getState().betPanelManagerModel.areAllBetSlipsExpanded;

    areAllBetSlipsExpanded
      ? BetDrawerLogic.collapseAllBetSlips()
      : BetDrawerLogic.expandAllBetSlips();
  }
}
